<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ resource.name }}</h3>
      <nav-secondary-customer :customer="customer" />
    </route-header>
    <div class="row">
      <div class="col-12 mb-3">
        <contacts v-if="customer && auth.can['customer_contacts']" :customer="customer" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <notes v-if="customer && auth.can['customer_notes']" :type="'customer'" :id="customer" />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <documents v-if="customer && auth.can['customer_documents']" :type="'customer'" :id="customer" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Customer',
  props: ['customer'],
  data () {
    return {
      domain: null
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resource: state => state.customer.data
    })
  },
  mounted () {
    this.show()
    this.$store.dispatch('index', { collection: 'Properties', path: 'customers', id: this.customer, tag: 'properties' })
  },
  methods: {
    show () {
      this.loading = true
      this.$store.dispatch('show', { object: this.$options.name, id: this.customer }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
